<template>
  <div>
    <Spinner v-if="loading" />
    <StaticDataTable class="static-table-list" v-show="!loading && !loadingError">
      <template v-slot:header>
        <tr>
          <th width="30%">Edgework</th>
          <th width="35%">Stock Allowance Override - Straight Line</th>
          <th width="35%">Stock Allowance Override - Arc</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="edgeworkConfig in edgeworkConfigList" :key="edgeworkConfig.id">
          <td class="font-weight-bold">
            {{edgeworkConfig.name}}
          </td>
          <td v-if="!editing">
            <span v-if="hasAllowanceForEdgework(edgeworkConfig.id)">{{allowanceForEdgework(edgeworkConfig.id)}}mm</span>
            <span v-else class="font-italic text-muted">Default</span>
          </td>
          <td v-if="editing">
            <FormInputText
              type="number"
              addon="mm" 
              :value="allowanceForEdgework(edgeworkConfig.id)"
              @input="updateAllowanceForEdgework(edgeworkConfig.id, $event)"
            />
          </td>
          <td v-if="!editing">
            <span v-if="hasArcAllowanceForEdgework(edgeworkConfig.id)">{{arcAllowanceForEdgework(edgeworkConfig.id)}}mm</span>
            <span v-else class="font-italic text-muted">Default</span>
          </td>
          <td v-if="editing">
            <FormInputText
              type="number"
              addon="mm" 
              :value="arcAllowanceForEdgework(edgeworkConfig.id)"
              @input="updateArcAllowanceForEdgework(edgeworkConfig.id, $event)"
            />
          </td>
        </tr>
      </template>
      <template v-slot:empty v-if="edgeworkConfigList.length == 0">
        No edgeworks found        
      </template>
    </StaticDataTable>
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>


<script>
import _ from 'lodash'
import formMixin from '@/mixins/form'

export default {
  name: 'StockEdgeworkAllowanceEditor',
  model: {
    event: 'update'
  },
  mixins: [formMixin],
  props: {
    editing: Boolean,
    value: Array
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      edgeworkConfigList: [],
      
      edgeworkAllowanceList: _.cloneDeep(this.$props.value || [])
    }
  },
  computed: {
    
  },
  watch: {
    value: {
      deep: true,
      handler: function() {
        this.$data.edgeworkAllowanceList = _.cloneDeep(this.$props.value)
      }
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    reloadData() {
      this.requestData()
    },
    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.orderEditorService.getOrderEditorEdgeworkList()
      .then(response => {
        this.edgeworkConfigList = response.data
      })
      .catch(err => {
        this.loadingError = 'Failed to load data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    hasAllowanceForEdgework(orderEditorEdgeworkConfigId) {
      let allowanceInfo = this.edgeworkAllowanceList.find(allowance => allowance.orderEditorEdgeworkConfigId == orderEditorEdgeworkConfigId)
      return (allowanceInfo && allowanceInfo.allowanceAmount !== null)
    },
    hasArcAllowanceForEdgework(orderEditorEdgeworkConfigId) {
      let allowanceInfo = this.edgeworkAllowanceList.find(allowance => allowance.orderEditorEdgeworkConfigId == orderEditorEdgeworkConfigId)
      return (allowanceInfo && allowanceInfo.allowanceAmountArc !== null)
    },
    allowanceForEdgework(orderEditorEdgeworkConfigId) {
      let allowanceInfo = this.edgeworkAllowanceList.find(allowance => allowance.orderEditorEdgeworkConfigId == orderEditorEdgeworkConfigId)
      if(allowanceInfo)
        return allowanceInfo.allowanceAmount
      return ''
    },
    arcAllowanceForEdgework(orderEditorEdgeworkConfigId) {
      let allowanceInfo = this.edgeworkAllowanceList.find(allowance => allowance.orderEditorEdgeworkConfigId == orderEditorEdgeworkConfigId)
      if(allowanceInfo)
        return allowanceInfo.allowanceAmountArc
      return ''
    },
    updateAllowanceForEdgework(orderEditorEdgeworkConfigId, allowanceAmount) {
      let allowanceInfo = this.edgeworkAllowanceList.find(allowance => allowance.orderEditorEdgeworkConfigId == orderEditorEdgeworkConfigId)
      if(allowanceInfo) {
        allowanceInfo.allowanceAmount = allowanceAmount ? parseInt(allowanceAmount) : null
      } else {
        this.edgeworkAllowanceList.push({
          orderEditorEdgeworkConfigId: orderEditorEdgeworkConfigId,
          allowanceAmount: allowanceAmount ? parseInt(allowanceAmount) : null,
          allowanceAmountArc: 0
        })        
      }

      // Remove 'none' values
      this.edgeworkAllowanceList = this.edgeworkAllowanceList.filter(allowance => allowance.allowanceAmount !== null || allowance.allowanceAmountArc !== null)

      this.$emit('update', this.edgeworkAllowanceList)
    },
    updateArcAllowanceForEdgework(orderEditorEdgeworkConfigId, allowanceAmountArc) {
      let allowanceInfo = this.edgeworkAllowanceList.find(allowance => allowance.orderEditorEdgeworkConfigId == orderEditorEdgeworkConfigId)
      if(allowanceInfo) {
        allowanceInfo.allowanceAmountArc = allowanceAmountArc ? parseInt(allowanceAmountArc) : null
      } else {
        this.edgeworkAllowanceList.push({
          orderEditorEdgeworkConfigId: orderEditorEdgeworkConfigId,
          allowanceAmount: 0,
          allowanceAmountArc: allowanceAmountArc ? parseInt(allowanceAmountArc) : null
        })        
      }

      // Remove 'none' values
      this.edgeworkAllowanceList = this.edgeworkAllowanceList.filter(allowance => allowance.allowanceAmount !== null || allowance.allowanceAmountArc !== null)

      this.$emit('update', this.edgeworkAllowanceList)
    }
    

  }


}
</script>